import { Button } from "@devhop/ui";
import { RefreshCwIcon } from "lucide-react";

type ScheduleChangeLogToolbarProps = {
  onRefresh?: () => void;
  isRefetching?: boolean;
};

export function ScheduleChangeLogToolbar({
  onRefresh,
  isRefetching = false,
}: ScheduleChangeLogToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">
            ບັນທຶກການປ່ຽນແປງຕາຕະລາງ
          </h2>
          <p className="text-muted-foreground">
            ເບິ່ງບັນທຶກການປ່ຽນແປງຕາຕະລາງຄລາດສ໌ ແລະ ການຈອງ.
          </p>
        </div>
        {onRefresh ? (
          <Button
            variant="outline"
            size="sm"
            onClick={onRefresh}
            disabled={isRefetching}
          >
            <RefreshCwIcon
              className={`mr-1 size-4 ${isRefetching ? "animate-spin" : ""}`}
            />
            ໂຫຼດໃໝ່
          </Button>
        ) : null}
      </div>
    </div>
  );
}
